import * as Dtos from "../dtos/Tmd.dtos";
import { IFormFilter } from "../reducers/index";

export const
    LoadMonitoringDocument: IMonitoringDocumentLoadActionCreator = () => {
        return {
            type: ACTION_MONITORINGDOCUMENT_LOAD
        }
    },
    LoadMonitoringDocumentsByMonitoringId: IMonitoringDocumentsLoadByMonitoringIdActionCreator = (monitoringId) => {
        return {
            type: ACTION_MONITORINGDOCUMENTS_LOAD_BY_MONITORING_ID,
            monitoringId
        }
    },
    LoadMonitoringDocumentById: IMonitoringDocumentLoadByIdActionCreator = (id) => {
        return {
            type: ACTION_MONITORINGDOCUMENT_LOAD_BY_ID,
            id
        }
    },
    LoadSuccess: IMonitoringDocumentLoadSuccessActionCreator = (formData, formState, formProperties, lookups, responseStatus) => {
        return {
            type: ACTION_MONITORINGDOCUMENT_LOAD_SUCCESS,
            formData,
            formState,
            formProperties,
            lookups,
            responseStatus
        }
    },
    LoadFailure: IMonitoringDocumentLoadFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_MONITORINGDOCUMENT_LOAD_FAILURE,
            responseStatus
        }
    },

    SaveMonitoringDocument: IMonitoringDocumentSaveActionCreator = (formData) => {
        return {
            type: ACTION_MONITORINGDOCUMENT_SAVE,
            formData
        }
    },
    SaveSuccess: IMonitoringDocumentSaveSuccessActionCreator = (formData, formState, responseStatus) => {
        return {
            type: ACTION_MONITORINGDOCUMENT_SAVE_SUCCESS,
            formData,
            formState,
            responseStatus
        }
    },
    SaveFailure: IMonitoringDocumentSaveFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_MONITORINGDOCUMENT_SAVE_FAILURE,
            responseStatus
        }
    },

    CreateMonitoringDocument: IMonitoringDocumentCreateActionCreator = (monitoringId) => {

        return {
            type: ACTION_MONITORINGDOCUMENT_CREATE,
            monitoringId
        }
    },
    CreateSuccess: IMonitoringDocumentCreateSuccessActionCreator = (formData, formState, formProperties, lookups) => {
        return {
            type: ACTION_MONITORINGDOCUMENT_CREATE_SUCCESS,
            formData,
            formState,
            formProperties,
            lookups
        }
    },
    CreateFailure: IMonitoringDocumentCreateFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_MONITORINGDOCUMENT_CREATE_FAILURE,
            responseStatus
        }
    },

    ValidateMonitoringDocument: IMonitoringDocumentValidateActionCreator = (formData) => {
        return {
            type: ACTION_MONITORINGDOCUMENT_VALIDATE,
            formData
        }
    },
    ValidateSuccess: IMonitoringDocumentValidateSuccessActionCreator = (formData, formState, responseStatus) => {
        return {
            type: ACTION_MONITORINGDOCUMENT_VALIDATE_SUCCESS,
            formData,
            formState,
            responseStatus
        }
    },
    ValidateFailure: IMonitoringDocumentValidateFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_MONITORINGDOCUMENT_VALIDATE_FAILURE,
            responseStatus
        }
    },

    Clear: IMonitoringDocumentClearActionCreator = (propertiesToClear?) => {
        return {
            type: ACTION_MONITORINGDOCUMENT_CLEAR,
            propertiesToClear
        }
    },

    Filter: IMonitoringDocumentFilterActionCreator = (formFilter) => {
        return {
            type: ACTION_MONITORINGDOCUMENT_FILTER,
            formFilter
        }
    };



export const
    ACTION_MONITORINGDOCUMENT_LOAD = "ACTION_MONITORINGDOCUMENT_LOAD",
    ACTION_MONITORINGDOCUMENTS_LOAD_BY_MONITORING_ID = "ACTION_MONITORINGDOCUMENTS_LOAD_BY_MONITORING_ID",
    ACTION_MONITORINGDOCUMENT_LOAD_BY_ID = "ACTION_MONITORINGDOCUMENT_LOAD_BY_ID",
    ACTION_MONITORINGDOCUMENT_LOAD_SUCCESS = "ACTION_MONITORINGDOCUMENT_LOAD_SUCCESS",
    ACTION_MONITORINGDOCUMENT_LOAD_FAILURE = "ACTION_MONITORINGDOCUMENT_LOAD_FAILURE",

    ACTION_MONITORINGDOCUMENT_SAVE = "ACTION_MONITORINGDOCUMENT_SAVE",
    ACTION_MONITORINGDOCUMENT_SAVE_SUCCESS = "ACTION_MONITORINGDOCUMENT_SAVE_SUCCESS",
    ACTION_MONITORINGDOCUMENT_SAVE_FAILURE = "ACTION_MONITORINGDOCUMENT_SAVE_FAILURE",

    ACTION_MONITORINGDOCUMENT_CREATE = "ACTION_MONITORINGDOCUMENT_CREATE",
    ACTION_MONITORINGDOCUMENT_CREATE_SUCCESS = "ACTION_MONITORINGDOCUMENT_CREATE_SUCCESS",
    ACTION_MONITORINGDOCUMENT_CREATE_FAILURE = "ACTION_MONITORINGDOCUMENT_CREATE_FAILURE",

    ACTION_MONITORINGDOCUMENT_VALIDATE = "ACTION_MONITORINGDOCUMENT_VALIDATE",
    ACTION_MONITORINGDOCUMENT_VALIDATE_SUCCESS = "ACTION_MONITORINGDOCUMENT_VALIDATE_SUCCESS",
    ACTION_MONITORINGDOCUMENT_VALIDATE_FAILURE = "ACTION_MONITORINGDOCUMENT_VALIDATE_FAILURE",

    ACTION_MONITORINGDOCUMENT_CLEAR = "ACTION_MONITORINGDOCUMENT_CLEAR",

    ACTION_MONITORINGDOCUMENT_FILTER = "ACTION_MONITORINGDOCUMENT_FILTER";

export interface IMonitoringDocumentLoadAction {
    type: "ACTION_MONITORINGDOCUMENT_LOAD";
}

export interface IMonitoringDocumentLoadActionCreator {
    (): IMonitoringDocumentLoadAction;
}

export interface IMonitoringDocumentLoadSuccessAction {
    type: "ACTION_MONITORINGDOCUMENT_LOAD_SUCCESS";
    formData: Dtos.MonitoringDocument | Dtos.MonitoringDocument[];
    formState: Dtos.FormState;
    formProperties: Dtos.FormProperty[];
    lookups: Dtos.Lookup[];
    responseStatus: Dtos.ResponseStatus;
}

export interface IMonitoringDocumentLoadSuccessActionCreator {
    (
        formData: Dtos.MonitoringDocument | Dtos.MonitoringDocument[],
        formState: Dtos.FormState,
        formProperties: Dtos.FormProperty[],
        lookups: Dtos.Lookup[],
        responseStatus: Dtos.ResponseStatus
    ): IMonitoringDocumentLoadSuccessAction;
}

export interface IMonitoringDocumentLoadFailureAction {
    type: "ACTION_MONITORINGDOCUMENT_LOAD_FAILURE";
    responseStatus: Dtos.ResponseStatus;
}

export interface IMonitoringDocumentLoadFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): IMonitoringDocumentLoadFailureAction;
}

export interface IMonitoringDocumentsLoadByMonitoringIdAction {
    type: "ACTION_MONITORINGDOCUMENTS_LOAD_BY_MONITORING_ID";
    monitoringId: number;
}

export interface IMonitoringDocumentsLoadByMonitoringIdActionCreator {
    (monitoringId: number): IMonitoringDocumentsLoadByMonitoringIdAction;
}

export interface IMonitoringDocumentLoadByIdAction {
    type: "ACTION_MONITORINGDOCUMENT_LOAD_BY_ID";
    id: number;
}

export interface IMonitoringDocumentLoadByIdActionCreator {
    (id: number): IMonitoringDocumentLoadByIdAction;
}


export interface IMonitoringDocumentSaveAction {
    type: "ACTION_MONITORINGDOCUMENT_SAVE";
    formData: Dtos.MonitoringDocument;

}

export interface IMonitoringDocumentSaveActionCreator {
    (
        formData: Dtos.MonitoringDocument
    ): IMonitoringDocumentSaveAction;
}

export interface IMonitoringDocumentSaveSuccessAction {
    type: "ACTION_MONITORINGDOCUMENT_SAVE_SUCCESS";
    formData: Dtos.MonitoringDocument;
    formState: Dtos.FormState,
    responseStatus: Dtos.ResponseStatus;
}

export interface IMonitoringDocumentSaveSuccessActionCreator {
    (
        formData: Dtos.MonitoringDocument,
        formState: Dtos.FormState,
        responseStatus: Dtos.ResponseStatus
    ): IMonitoringDocumentSaveSuccessAction;
}

export interface IMonitoringDocumentSaveFailureAction {
    type: "ACTION_MONITORINGDOCUMENT_SAVE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface IMonitoringDocumentSaveFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): IMonitoringDocumentSaveFailureAction;
}

export interface IMonitoringDocumentCreateAction {
    type: "ACTION_MONITORINGDOCUMENT_CREATE",
    monitoringId: number
}

export interface IMonitoringDocumentCreateActionCreator {
    (monitoringId: number): IMonitoringDocumentCreateAction
}

export interface IMonitoringDocumentCreateSuccessAction {
    type: "ACTION_MONITORINGDOCUMENT_CREATE_SUCCESS";
    formData: Dtos.MonitoringDocument;
    formState: Dtos.FormState;
    formProperties: Dtos.FormProperty[];
    lookups: Dtos.Lookup[];
}

export interface IMonitoringDocumentCreateSuccessActionCreator {
    (
        formData: Dtos.MonitoringDocument,
        formState: Dtos.FormState,
        formProperties: Dtos.FormProperty[],
        lookups: Dtos.Lookup[]
    ): IMonitoringDocumentCreateSuccessAction;
}

export interface IMonitoringDocumentCreateFailureAction {
    type: "ACTION_MONITORINGDOCUMENT_CREATE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface IMonitoringDocumentCreateFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): IMonitoringDocumentCreateFailureAction;
}

export interface IMonitoringDocumentValidateAction {
    type: "ACTION_MONITORINGDOCUMENT_VALIDATE";
    formData: Dtos.MonitoringDocument;

}

export interface IMonitoringDocumentValidateActionCreator {
    (
        formData: Dtos.MonitoringDocument
    ): IMonitoringDocumentValidateAction;
}

export interface IMonitoringDocumentValidateSuccessAction {
    type: "ACTION_MONITORINGDOCUMENT_VALIDATE_SUCCESS";
    formData: Dtos.MonitoringDocument;
    formState: Dtos.FormState,
    responseStatus: Dtos.ResponseStatus;
}

export interface IMonitoringDocumentValidateSuccessActionCreator {
    (
        formData: Dtos.MonitoringDocument,
        formState: Dtos.FormState,
        responseStatus: Dtos.ResponseStatus
    ): IMonitoringDocumentValidateSuccessAction;
}

export interface IMonitoringDocumentValidateFailureAction {
    type: "ACTION_MONITORINGDOCUMENT_VALIDATE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface IMonitoringDocumentValidateFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): IMonitoringDocumentValidateFailureAction;
}

export interface IMonitoringDocumentClearAction {
    type: "ACTION_MONITORINGDOCUMENT_CLEAR";
    propertiesToClear?: string[];
}

export interface IMonitoringDocumentClearActionCreator {
    (propertiesToClear?: string[]): IMonitoringDocumentClearAction;
}

export interface IMonitoringDocumentFilterActionCreator {
    (formFilter: IFormFilter): IMonitoringDocumentFilterAction;
}

export interface IMonitoringDocumentFilterAction {
    type: "ACTION_MONITORINGDOCUMENT_FILTER";
    formFilter: IFormFilter;
}

export type MonitoringDocumentAction =
    IMonitoringDocumentLoadAction |
    IMonitoringDocumentsLoadByMonitoringIdAction |
    IMonitoringDocumentLoadByIdAction |
    IMonitoringDocumentLoadFailureAction |
    IMonitoringDocumentLoadSuccessAction |
    IMonitoringDocumentSaveAction |
    IMonitoringDocumentSaveSuccessAction |
    IMonitoringDocumentSaveFailureAction |
    IMonitoringDocumentCreateAction |
    IMonitoringDocumentCreateSuccessAction |
    IMonitoringDocumentCreateFailureAction |
    IMonitoringDocumentValidateAction |
    IMonitoringDocumentValidateSuccessAction |
    IMonitoringDocumentValidateFailureAction |
    IMonitoringDocumentClearAction | 
    IMonitoringDocumentFilterAction;
